<template>
    <div class="main">
        <div class="header">
            <div class="h-left">
                <span class="c-n" @click="goBack">{{ currentClassName}}</span>
                <span class="c-c">/</span>
                <span class="c-t">创建小组</span>
            </div>
            <div class="h-right">
                <div class="cancel" @click="goBack">取消</div>
                <div class="sure" @click="createGroup">确认</div>
            </div>
        </div>
        <div class="content">
            <div class="g-n">小组名</div>
            <div class="new-group">
                <a-input style="width:1040px;height:40px;" v-model="groupName" />
            </div>
            <div class="g-n mt20">小组长</div>
            <div class="mt20">
                <div class="leader-mess" v-if="leaderMess">
                    <img class="leader-img"
                        :src="leaderMess.photo ? resBasePath + '/' + leaderMess.photo : checkNameImg" alt="">
                    <span class="name">{{ leaderMess.userName}}</span>
                    <span class="change" @click="choseLeader">更换</span>
                </div>
                <a-button type="primary" v-if="!leaderMess" @click="choseLeader">选择组长</a-button>
            </div>
            <div class="g-n mt20">选择成员</div>
            <div class="choice-stu">
                <!-- <span>已选{{ this.selectedStudentList.length}}人：</span> -->
                <span class="name-n" v-for="(item,index) in this.selectedStudentList" :key="index">{{item.userName}}</span>
            </div>
            <ul class="m-ul">
                <li class="mli" @click="checkFun(item,index)" v-for="(item,index) in memberList" :key="index">
                    <div v-show="item.selected" class="photoCheck"></div>
                    <img class="user-photo" :src="item.photo ? resBasePath+'/'+ item.photo : checkNameImg" alt="">
                    <div class="name">{{ item.userName}}</div>
                </li>
            </ul>
        </div>
        <div v-if="leaderVis">
            <a-modal title="选择组长" width="700px" footer="" :visible="leaderVis" @cancel="leaderCancel">
                <ul class="studentsUl">
                    <li :class="currenStudentIndex === index ?'studentsLi-a':'studentsLi'"
                        @click="checkName(item,index)" v-for="(item,index) in memberList" :key="index">{{
                        item.userName}}</li>
                </ul>
            </a-modal>
        </div>
    </div>
</template>

<script>
import requestUrl from '../../../utils/requestUrl.js'
export default {
  name: 'newGroup',
  data () {
    return {
      requestUrl,
      resBasePath: this.$resBasePath,
      groupName: '',
      currentClassId: localStorage.getItem('classId'), // 当前班级id
      currentClassName: localStorage.getItem('className'),
      access_token: this.$store.state.access_token,
      memberList: [],
      teaList: [],
      checkNameList: [],
      checkNameImg: require('../../../assets/imgs/student.png'),
      selectedStudentList: [],
      classMess: {},
      leaderVis: false,
      currenStudentIndex: -1,
      leaderMess: ''
    }
  },
  mounted () {
    console.log(this)
    this.classMess = this.$store.state.classList.find((item) => {
      return item.id === this.currentClassId
    })
    this.getStudentList()
  },

  methods: {
    checkName (item, index) {
      this.currenStudentIndex = index
      this.leaderMess = item
    },
    goBack () {
      // if (this.$store.state.groupList.length < 1) {
      //   this.$router.push({name: 'Class'})
      // } else {
      //
      // }
      this.$router.push({ name: 'Groups' })
    },
    choseLeader () {
      this.leaderVis = true
    },
    leaderCancel () {
      this.leaderVis = false
    },
    getStudentList () {
      const param = {
        access_token: this.access_token,
        classId: this.currentClassId
      }
      this.$http.post(requestUrl.getClaMembersByClassId, param).then((res) => {
        // this.memberList = res
        this.memberList = res.filter(item => item.isTea === 0)
        this.teaList = res.filter(item => item.isTea === 1)
        this.memberList.forEach(item => {
          item.selected = false
        })
      })
    },
    createGroup () {
      if (this.selectedStudentList.length === 0) {
        this.$message.error('请选择成员')
        return
      }
      if (this.leaderMess) {
        this.selectedStudentList.map(u => {
          if (u.userId === this.leaderMess.id) {
            u.isGroupLeader = 1
          }
          return this.selectedStudentList
        })
      }
      if (this.groupName === '') {
        this.$message.warning('请输入小组名称')
        return
      }
      if (this.groupName.length > 8) {
        this.$message.warning('小组名称不能超过8个字')
        return
      }
      // 将老师添加到群组
      this.selectedStudentList.push(...this.teaList)
      const param = {
        access_token: this.access_token,
        classId: this.currentClassId,
        groupName: this.groupName,
        users: this.selectedStudentList
      }
      this.$http.post(requestUrl.createClassGroup, param).then((res) => {
        if (res) {
          this.$message.success('创建群组成功')
          this.$router.push({ name: 'Groups' })
        }
      })
    },
    checkFun (item, index) {
      if (!item.selected) { // 选中状态时点击
        this.$forceUpdate()
        item.selected = true// 变为不选中状态
        this.selectedStudentList.push({ userId: item.id, isGroupLeader: 0, name: item.userName })// 更新数组（不选中项）
      } else if (item.selected) { // 不选中状态时点击
        item.selected = false// 变为选中状态
        this.$forceUpdate()
        const i = this.selectedStudentList.indexOf(item.id)// 找到当前点击项
        this.selectedStudentList.splice(i, 1)// 移除一个不选中项
      }
    }
  }
}
</script>

<style lang="less" scoped>
    ul,li{
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .main{
        width: 1100px;
        margin: 0 auto;
       // background: #f1f0f0;
        font-family: PingFangSC-Regular, PingFang SC;
        .header{
            line-height: 40px;
            padding: 15px 0;
            display: flex;
            justify-content: space-between;
            .h-left{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                .c-n {
                    color: #867D7B;
                    cursor: pointer;
                }
                .c-c {
                    margin: 0 4px;
                }
                .c-t{
                    color: #333;
                }
            }
            .h-right{
                display: flex;
                .cancel,.sure{
                    width: 80px;
                    height: 24px;
                    line-height: 24px;
                    border-radius: 2px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    text-align: center;
                    margin-top: 10px;
                    cursor: pointer;
                }
                .cancel{
                    border: 1px solid #DBD1CD;
                    color: #867D7B;
                    background: #F1F0F0;
                    margin-right: 10px;
                }
                .sure{
                    color: #FFFFFF;
                    background: @primary-color;
                }
            }
        }
        .content{
            padding: 20px;
            width: 1100px;
            min-height: 500px;
            background: #fff;
            border-radius: 5px;
            .g-n{
                font-size: 14px;
                color: #867D7B;
            }
            .new-group{
                margin-top: 10px;
            }
            .m-ul{
                display: flex;
                flex-wrap: wrap;
                margin-top: 10px;
                .mli{
                    width: 68px;
                    margin-top: 5px;
                    text-align: center;
                    cursor: pointer;
                    position: relative;
                    .user-photo{
                        width: 48px;
                        height: 48px;
                        border-radius: 4px;
                    }
                    .photoCheck{
                        width: 48px;
                        height: 48px;
                        border-radius: 4px;
                        position: absolute;
                        left: 10px;
                        top: 0;
                        z-index: 99;
                        background: url('../../../assets/imgs/check.png');
                        background-size: cover;
                        opacity: .9;
                    }
                    .name{
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #867D7B;
                        line-height: 20px;
                    }

                }
            }
        }
    }

    .mt20{
        margin-top: 20px;
    }
    .select {
        background: url('../../../assets/imgs/student.png');
        background-size: 100% 100%;
        width: 48px;
        height: 48px;
        border-radius: 4px;
        z-index: 99;
    }
    .studentsUl{
        display: flex;
        flex-wrap: wrap;
        min-height: 200px;
        .studentsLi{
            cursor: pointer;
           height: 26px;
           text-align: center;
           background:#F2F2F2;
           color: #333;
           font-size: 12px;
           margin-top: 12px;
           margin-left: 8px;
           padding: 4px 15px;
           border-radius: 2px;
        }
        .studentsLi-a {
            cursor: pointer;
            height: 26px;
            text-align: center;
            background: @primary-color;
            color: #fff;
            font-size: 12px;
            margin-top: 12px;
            margin-left: 8px;
            padding: 4px 15px;
            border-radius: 2px;
        }
    }
    /deep/.ant-modal-body{
        padding:0 12px 12px;
    }
    .leader-mess{
        width: 300px;
        height: 48px;
        line-height: 48px;
        font-size: 12px;
        background: #F1F0F0;
        border-radius: 4px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        display: flex;
        padding: 0 10px;
        .leader-img{
            width: 32px;
            height: 32px;
            border-radius: 4px;
            margin-top: 9px;
        }
        .name{

            font-weight: 400;
            color: #333;
            margin-left: 20px;
        }
        .change {
            color: @primary-color;
            margin-left: auto;
            cursor: pointer;
        }
        .choice-stu{
            .name-n{
                color: #333;
                font-size: 16px;
            }
        }
    }
</style>
